import { useAPIClient } from '@src/api';
import { useBaseQuery } from '@src/corelib/query';
import type { BuildQueryDescriptorParams } from '@src/corelib/query/utils';

export function useQuery<TQueryFnData = unknown, TData = TQueryFnData>(
  url: string,
  params?: BuildQueryDescriptorParams<TQueryFnData, Error, TData>,
) {
  const apiClient = useAPIClient();
  return useBaseQuery<TQueryFnData, TData>(url, apiClient, params);
}

export default useQuery;
